// Shim for form-data to use native browser FormData
// This allows code to import 'form-data' but use the native browser FormData API
module.exports = FormData
